import { makeStyles } from '@material-ui/core/styles';
import { withStyles } from '@material-ui/styles';
import {
  MuiAccordion,
  MuiAccordionDetails,
  MuiAccordionSummary,
} from '@/features/shared/material-ui';
import typography from '@/theme/typography';
import { TextColors, TextOpacities } from '@/utils/constants';
import { hexToRGBA } from '@/utils/helpers';

export const Accordion = withStyles({
  root: {
    background: 'transparent',
    border: 'initial',
    boxShadow: 'none',
    '&:not(:last-child)': {
      borderBottom: 0,
    },
    '&:before': {
      display: 'none',
    },
    '&$expanded': {
      margin: 'auto',
    },
    '&:first-child .accordion-summary': {
      borderTop: '1px solid transparent',
    },
    '&:last-child .accordion-summary': {
      borderBottom: '1px solid transparent',
    },
  },
  expanded: {},
})(MuiAccordion);

export const AccordionSummary = withStyles((theme) => ({
  root: {
    padding: `0 ${theme.spacing(0.5)}px`,
    backgroundColor: 'transparent',
    // TODO: (Benjamin Arambide): use theme colors w/ opacity instead
    borderTop: '1px solid #22282F',
    borderBottom: '1px solid #22282F',
    marginBottom: -1,
    minHeight: 56,
    justifyContent: 'flex-start',
    '&$expanded': {
      minHeight: 56,
      borderBottom: 0,
    },
    '& .MuiIconButton-root': {
      color: '#00AEEF',
    },
  },
  content: {
    flexGrow: 0,
    '&$expanded': {
      margin: '12px 0',
    },
  },
  expanded: {},
}))(MuiAccordionSummary);

export const AccordionDetails = withStyles((theme) => ({
  root: {
    padding: `${theme.spacing(1)}px ${theme.spacing(0.5)}px ${theme.spacing(2)}px ${theme.spacing(
      0.5,
    )}px`,
  },
}))(MuiAccordionDetails);

export const useStyles = makeStyles(
  (muiTheme) => ({
    root: {},
    groupTitle: {
      '& h1, h2, h3, h4, h5, h6, p': {
        ...typography.caption,
        fontSize: '10px',
        fontWeight: 'bold',
        color: hexToRGBA(TextColors.light, TextOpacities.light2),
      },
      marginBottom: muiTheme.spacing(2.5),
    },
    title: {
      '& h1, h2, h3, h4, h5, h6, p': {
        ...typography.body1,
        color: TextColors.light,
      },
    },
    content: {
      '& h1, h2, h3, h4, h5, h6, p': {
        ...typography.body2,
        color: `${hexToRGBA(TextColors.light, TextOpacities.light2)} !important`,
      },
    },
  }),
  { name: 'GenAccordionGroup' },
);
